// @flow
/** @jsx h */
import { styled } from 'goober';
import Skeleton from '../Skeleton';

const Container = styled('div')`
  width: 100%;
  background: #ffffff;
  .lenderHeader {
    display: flex;
    flex-direction: row;
    background: #f5f5f5;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    height: 52px;
  }
  .innerLenderHeader {
    display: flex;
    align-items: center;
  }
  .lenderLogo {
    width: 32px;
    height: 32px;
    border-radius: 2px;
    margin-right: 10px;
  }
  .shareBtn {
    width: 100px;
    height: 35px;
    border-radius: 8px;
    margin: 0px 10px;
  }
  .lenderIcon {
    width: 100%;
    height: 100%;
  }
  .lenderName {
    max-width: 180px;
    width: 100%;
    height: 13px;
    border-radius: 2px;
  }
  .emiPerMonth {
    width: 220px;
    height: 13px;
    border-radius: 2px;
    margin-top: 3px;
  }
`;

const LenderDetailsSkeleton = () => {
  return (
    <Container>
      <Skeleton
        style={{
          height: '70px',
          marginBottom: '8px',
          borderRadius: '0px 0px 20px 20px',
        }}
      />
      <div className='lenderHeader'>
        <div className='innerLenderHeader'>
          <Skeleton className='lenderLogo' />
          <div className='lenderDetails'>
            <Skeleton className='lenderName' />
            <Skeleton className='emiPerMonth' />
          </div>
        </div>
        <Skeleton className='shareBtn' />
      </div>
      <Skeleton
        style={{
          height: '20px',
          borderRadius: '2px',
          maxWidth: '70%',
          width: '100%',
          margin: '16px',
        }}
      />
      <div className='lenderHeader'>
        {Array.apply(null, Array(3)).map((index) => {
          return (
            <Skeleton
              key={index}
              style={{
                height: '20px',
                borderRadius: '2px',
                maxWidth: '30%',
                width: '100%',
              }}
            />
          );
        })}
      </div>
      {Array.apply(null, Array(5)).map((e, i) => {
        return (
          <div className='lenderHeader' style={{ backgroundColor: '#ffffff' }}>
            {Array.apply(null, Array(3)).map((index) => {
              return (
                <Skeleton
                  key={index}
                  style={{
                    height: '20px',
                    borderRadius: '2px',
                    maxWidth: '30%',
                    width: '100%',
                  }}
                />
              );
            })}
          </div>
        );
      })}
      <Skeleton
        style={{
          height: '20px',
          borderRadius: '2px',
          maxWidth: '70%',
          width: '100%',
          margin: '30px auto',
        }}
      />
      <Skeleton style={{ height: '64px', margin: '16px 0px 8px 0px' }} />
    </Container>
  );
};

export default LenderDetailsSkeleton;



// WEBPACK FOOTER //
// ./components/salesApp/skeletonScreens/LenderDetailsSkeleton.js